import React, { useState } from 'react';
import PremiumPaywall from '../components/PremiumPaywall';
import AlternativePaywall from '../components/AlternativePaywall';

const PreviewPaywalls = () => {
  const [showPremium, setShowPremium] = useState(false);
  const [showAlternative, setShowAlternative] = useState(false);

  return (
    <div className="min-h-screen bg-[#FAFAF9] font-manrope p-8 flex flex-col items-center gap-6">
      <div className="max-w-2xl w-full text-center">
        <h1 className="text-2xl font-semibold text-stone-900 mb-2">Paywalls preview (dev)</h1>
        <p className="text-sm text-stone-600 mb-6">Quick preview page for Premium & Alternative paywalls (development only).</p>
        <div className="flex gap-3 justify-center">
          <button onClick={() => setShowPremium(true)} className="px-4 py-2 bg-stone-900 text-white rounded-none">Show Premium paywall</button>
          <button onClick={() => setShowAlternative(true)} className="px-4 py-2 bg-stone-900 text-white rounded-none">Show Alternative paywall</button>
          <a href="/subscription" className="px-4 py-2 bg-stone-100 text-stone-800 rounded-none">Open Subscription page</a>
        </div>
      </div>

      {/* Small previews (visual inspector) */}
      <div className="w-full max-w-md mt-6 bg-white rounded-xl border border-stone-100 p-4 text-left">
        <h3 className="text-sm font-medium text-stone-900 mb-2">Notes</h3>
        <p className="text-xs text-stone-600">Use the buttons above to open the modal paywalls. This page exists only in development previews.</p>
      </div>

      {/* Render paywalls when requested */}
      {showPremium && (
        <PremiumPaywall userId="preview-user" onClose={() => setShowPremium(false)} />
      )}

      {showAlternative && (
        <AlternativePaywall isOpen={true} onClose={() => setShowAlternative(false)} onUpgrade={() => setShowAlternative(false)} />
      )}
    </div>
  );
};

export default PreviewPaywalls;
